module.exports = __webpack_public_path__ + "static/media/icon3.3c1ee2b6.svg";